module.exports = __webpack_public_path__ + "img/bondyd.ca996bdb.jpg";